<template>
  <custom-dialog width="600px" :title="model.title" :visible="visible" v-on="$listeners">
    <div class="dialog-body">
      <t-upload v-model="attachList" :limit="3" bizType="deliveryMonth" :bizId="model.data.orderDeliveryMonthId"
        ref="file" :autoUpload="false" type="dragFile" accept="image/*"></t-upload>
    </div>
    <div slot="footer" class="dialog-footer">
      <el-button @click="visible = false">{{ $t('Common.com_cancel') }}</el-button>
      <el-button :disabled="!attachList.length" type="primary" @click="onConfirm">{{ $t('Common.com_confirm') }}</el-button>
    </div>
  </custom-dialog>
</template>

<script>
import apis from '@/utils/apis';
import dialogMixins from '@/mixins/dialog_mixins';
import tUpload from '@/components/upload';

export default {
  mixins: [dialogMixins],
  components: {
    tUpload
  },
  data() {
    return {
      attachList: [],
    };
  },
  mounted() {
  },
  methods: {
    async onConfirm() {
      const list = await this.$refs.file.submit();
      await this.$postJSON(apis.orderDeliveryMonthAttach, {
        bizId: this.model.data.orderDeliveryMonthId,
        attachList: list,
      });
      this.$message({
        message: this.$t('Common.com_handle_success'),
        type: 'success',
      });
      this.$emit('success');
      this.close();
    },
    onCancel() {
      this.close();
    },
    close() {
      this.$emit('close');
    }
  },
};
</script>

<style lang="scss"></style>
